import { Component, OnInit } from '@angular/core';
import { ChatService } from '../../services/chat.service';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { map } from 'rxjs/operators';
import * as moment from "moment-timezone";

@Component({
  selector: 'app-chat-room',
  templateUrl: './room.component.html',
  styleUrls: ['./room.component.scss']
})
export class ChatRoomComponent implements OnInit {
  userRooms$: Observable<any>;
  systemNotification$: Observable<any>;
  rooms: any[];
  isLoaded: false;

  constructor(
    public cs: ChatService,
    public auth: AuthService
  ) {}

  ngOnInit() {
    const source = this.cs.getUserChats();
    this.userRooms$ = this.cs.getRooms(source);

    this.systemNotification$ = this.cs.getLastNotificationMessage(this.cs.getLastNotification())
  }

  getTargetUser(room, index) {
    this.cs.getTargetUser(room).then(response => {
      this.rooms[index].target = {
        displayName: response.data().displayName,
        photoURL: response.data().photoURL,
        badge: this.rooms[index].target.badge
      }
    });
  }

  async getRooms() {
    this.userRooms$.subscribe(res => {
      this.rooms = []

      res.map(room => {
        this.rooms.push(Object.assign({
          target: {
            photoURL: '',
            displayName: '',
            badge: this.auth.user.role === AuthService.USER_ROLE ? room.vtuber.count : room.user.count
          } 
        }, ...room))

        this.getTargetUser(room, this.rooms.length - 1)
      })
    })
  }

}
